import '~/common-styles';
import './styles/core.scss';

const [, orgUrl, ,] = window.location.pathname.split('/');

const publicPages = ['public-doc', 'cli'];

if (publicPages.some((path) => path === orgUrl)) {
  import('./apps/PublicApp');
} else {
  import('./apps/App');
}
